<template>
  <div class>
    <div class="chunk1">
      <img src="../assets/home/banner.png" style="width:60%; margin-left: 40%; margin-bottom: 4%; z-index: -1;" alt>
      <img src="../assets/home/logo.png" style="width: 11%; position: absolute;top:6%; left: 10%;">
      <!-- <div
        id="navbar"
        class="hidden-xs hidden-sm"
      >
        <div class="container">
          <div class="row">
            <div class="col-md-3">
              <div class>
                <img
                  src="../assets/home/logo.png"
                  style="width: 10.2rem;"
                >
              </div>
            </div>
            <div
              class="col-md-9"
              style="font-size:1.56rem;"
            >
              <div class="row">
                <div class="col-md-2 col-md-offset-2">
                  <span
                    class="active"
                    @click="scrollTo()"
                  >首页</span>
                </div>
                <div class="col-md-2">
                  <span @click="scrollTo('.chunk6')">客户案例</span>
                </div>
                <div class="col-md-2">
                  <span @click="scrollTo('.chunk4')">功能模块</span>
                </div>
                <div class="col-md-2">
                  <span @click="scrollTo('.chunk3')">系统特点</span>
                </div>
                <div class="col-md-2">
                  <span @click="scrollTo('.chunk5')">联系我们</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <div style="position: absolute;top: 40%; left: 10%;color: #ffffff; text-align: center;">
        <div style="font-family: PingFang-SC-Medium;font-size: 3.69rem;">北京明思科技有限公司</div>
        <div style="width: 13.08rem;	height: 0.08rem;	background-color: #19a4b7;margin: 1rem auto;"></div>
        <div style="width: 56.23rem;	font-family: MyriadPro-Regular;	font-size: 1.23rem;  line-height: 4rem;font-weight: normal;">
          "2015年，是企业软件、系统、移动支付服务的提供商。在企业软件开发升级、企业收费系统
          升级优化、支付模式整合创新等方面取得了优异的成绩。明思科技坚持以人为本，立志于为客户提供更简单、
          更快捷、更安全、更经济的产品和服务，从而赢得客户的信赖与长期合作."
        </div>
      </div>
    </div>

    <div class="chunk6">
      <div class="container">
        <div class="lt-title" style="margin-bottom:6rem;">我们的服务</div>
        <div class="row">
          <div class="col-md-4" style="height: 36rem;text-align:center;">
            <img src="../assets/home/xls.png" style="margin: 7rem 0 3rem 0;width:12rem;">
            <div style="font-family: PingFang-SC-Bold;	font-size: 3rem;	color: #29363b;font-weight: normal;">新零售解决方案</div>
          </div>
          <div class="col-md-4">
            <div :class="['row mdl-xls',{'mdl-xls-active':mdlXls==1}]" @click="mdlXls=1">
              <div class="col-md-6" style="text-align:center;">
                <img src="../assets/home/xls-dp.png" style="width: 2.42rem; margin: auto;">
              </div>
              <div class="col-md-6">
                <font>大屏自助购</font>
              </div>
            </div>
            <div :class="['row mdl-xls',{'mdl-xls-active':mdlXls==2}]" @click="mdlXls=2">
              <div class="col-md-6" style="text-align:center;">
                <img src="../assets/home/xls-pos.png" style="width: 2.81rem; margin:auto;">
              </div>
              <div class="col-md-6">
                <font>手持款台</font>
              </div>
            </div>
            <div :class="['row mdl-xls',{'mdl-xls-active':mdlXls==3}]" @click="mdlXls=3">
              <div class="col-md-6" style="text-align:center;">
                <img src="../assets/home/xls-smg.png" style="width: 4.19rem;; margin: auto;">
              </div>
              <div class="col-md-6">
                <font>小程序扫码购</font>
              </div>
            </div>
          </div>
          <div class="col-md-4" style="background-color: #e5ffff;height:36rem;">
            <div v-if="mdlXls==1">
              <div style="text-align: center;padding:1rem">
                <img src="../assets/home/xls-dp-1.png" width="100%">
              </div>
              <div style="width:17rem;margin:auto;line-height: 3rem;padding-top:2rem;">（1）顾客自助扫码购物
                <br>（2）无需下载APP
                <br>（3）会员、非会员都能用
                <br>（4）支持微信、支付宝等快捷支付
              </div>
            </div>
            <div v-if="mdlXls==2">
              <div style="text-align: center;padding:1rem">
                <img src="../assets/home/xls-dp-2.png" style="width: 8rem;">
              </div>
              <div style="width:17rem;margin:auto;line-height: 3rem;padding-top:2rem;">（1）支持售卖全场商品
                <br>（2）支持售卖部分商品
                <br>（3）多种识别商品方式
              </div>
            </div>
            <div v-if="mdlXls==3">
              <div style="text-align: center;padding:1rem">
                <img src="../assets/home/xls-dp-3.png" width="100%">
              </div>
              <div style="width:20rem;margin:auto;line-height: 3rem;padding-top:2rem;">（1）基于微信小程序
                <br>（2）自助购价格与店面价格相同
                <br>（3）支持会员优惠、积分、促销等
                <br>（4）订单核验支持单单核验或抽查核验
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4" style="background-color: #f9f0ff;height:36rem;">
            <div v-if="mdlYx==1">
              <div style="padding:1rem">
                <img src="../assets/home/yxgl-kq-3.png" style="width: 12rem;">
              </div>
              <div style="width:18rem; float: right;">（1）会员信息管理
                <br>（2）会员专属促销管活动
                <br>（3）会员运营管理
              </div>
            </div>
            <div v-if="mdlYx==2">
              <div style="padding:1rem">
                <img src="../assets/home/yxgl-kq-2.png" style="width: 12rem;">
              </div>
              <div style="width:18rem; float: right;">（1）制卡快捷，用卡安全，管理便捷
                <br>（2）亿级消费平台，获客轻松
                <br>（3）赠送亲友，提升价值
              </div>
            </div>
            <div v-if="mdlYx==3">
              <div style="padding:1rem">
                <img src="../assets/home/yxgl-kq-1.png" style="width: 12rem;">
              </div>
              <div style="width:17rem; float: right;">（1）单品支付券
                <br>（2）支付代金券
                <br>（3）支付营销活动
              </div>
            </div>
            <div v-if="mdlYx==4">
              <div style="padding:1rem">
                <img src="../assets/home/yxgl-kq-4.png" style="width: 12rem;">
              </div>
              <div style="width:17rem; float: right;">（1）私有化管理平台
                <br>（2）多种会员标签系统
                <br>（3）地区推送精准运营
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div :class="['row mdl-yx',{'mdl-yx-active':mdlYx==1}]" @click="mdlYx=1">
              <div class="col-md-6" style="text-align:center;">
                <img src="../assets/home/yxgl-hy.png" style="width: 4.19rem;; margin: auto;">
              </div>
              <div class="col-md-6">
                <font>CRM会员管理</font>
              </div>
            </div>
            <div :class="['row mdl-yx',{'mdl-yx-active':mdlYx==2}]" @click="mdlYx=2">
              <div class="col-md-6" style="text-align:center;">
                <img src="../assets/home//yxgl-lpk.png" style="width: 3.81rem; margin:auto;">
              </div>
              <div class="col-md-6">
                <font>电子礼品卡系统</font>
              </div>
            </div>
            <div :class="['row mdl-yx',{'mdl-yx-active':mdlYx==3}]" @click="mdlYx=3">
              <div class="col-md-6" style="text-align:center;">
                <img src="../assets/home//yxgl-kj.png" style="width: 3.42rem; margin: auto;">
              </div>
              <div class="col-md-6">
                <font>卡卷系统</font>
              </div>
            </div>
            <div :class="['row mdl-yx',{'mdl-yx-active':mdlYx==4}]" @click="mdlYx=4">
              <div class="col-md-6" style="text-align:center;">
                <img src="../assets/home/yxgl-gzh.png" style="width: 4.19rem;; margin: auto;">
              </div>
              <div class="col-md-6">
                <font>公众号系统</font>
              </div>
            </div>
          </div>
          <div class="col-md-4" style="height: 36rem;text-align:center;">
            <img src="../assets/home/yxgl.png" style="margin: 7rem 0 3rem 0;width:12rem;">
            <div style="font-family: PingFang-SC-Bold;	font-size: 3rem;	color: #29363b;font-weight: normal;">营销管理系统</div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4" style="height: 36rem;text-align:center;">
            <img src="../assets/home/scxt.png" style="margin: 7rem 0 3rem 0;width:16rem;">
            <div style="font-family: PingFang-SC-Bold;	font-size: 3rem;	color: #29363b;font-weight: normal;">商超系统</div>
          </div>
          <div class="col-md-4">
            <div :class="['row mdl-sc',{'mdl-sc-active':mdlSc==1}]" @click="mdlSc=1">
              <div class="col-md-6" style="text-align:center;">
                <img src="../assets/home/scxt-sy.png" style="width: 3.81rem; margin:auto;">
              </div>
              <div class="col-md-6">
                <font>收银系统</font>
              </div>
            </div>
            <div :class="['row mdl-sc',{'mdl-sc-active':mdlSc==2}]" @click="mdlSc=2">
              <div class="col-md-6" style="text-align:center;">
                <img src="../assets/home/scxt-sjk.png" style="width: 4.19rem;; margin: auto;">
              </div>
              <div class="col-md-6">
                <font>云POS</font>
              </div>
            </div>
          </div>
          <div class="col-md-4" style="background-color: #e1ffe2;height:36rem;">
            <div v-if="mdlSc==1">
              <div style="text-align: center;padding:1rem">
                <img src="../assets/home/scxt-sy-1.png" style="width:16rem;">
              </div>
              <div style="width:17rem;margin:auto;padding-top:2rem;">（1）多形态收银系统
                <br>（2）支持个性化定制
                <br>（3）满足各行业需求
              </div>
            </div>
            <div v-if="mdlSc==2">
              <div style="text-align: center;padding:1rem">
                <img src="../assets/home/scxt-sy-2.png" style="width:25rem;">
              </div>
              <div style="width:17rem;margin:auto;padding-top:2rem;">（1）打造云POS服务体系
                <br>（2）提供模块化云系统
                <br>（3）提供云数据存储服务
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-md-offset-2">
            <img src="../assets/home/logo.png">
          </div>
          <div class="col-md-5" style="text-align: left;font-family: PingFang-SC-Medium;color: #29363b;font-size: 0.88rem; margin-top: 1.3rem;">公司地址：北京市海淀区知春路汉荣家园3号楼228
            <br>联系电话：173-4440-0420
            <br>邮 箱：geyunze@mingsitech.com
          </div>
        </div>
        <div style="height: 0.04rem;margin: 1rem 10%;background-color: #a7a7a7;"></div>
        	<!-- color: #29363b; -->
        <a href="https://beian.miit.gov.cn" style="font-family: PingFang-SC-Medium;font-size: 0.62rem;" class="beian">©{{tYear}}北京明思科技有限公司版权所有 | <span>{{prepare}}</span></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      mdlXls: "1",
      mdlYx: 1,
      mdlSc: 1,
      tYear :new Date().getFullYear(),
      prepare:'京ICP备16034536号-2'
    };
  },
  mounted() {
    console.log(location.href);
    if(location.href.indexOf('enjoyof')>0){
      this.prepare = '京ICP备16034536号-3'
    }
    console.log(this.tYear)
    // $(window).scroll(function() {
    //   const Top1 = $(".chunk6").offset().top - 300;
    //   const Top2 = $(".chunk4").offset().top - 300;
    //   const Top3 = $(".chunk3").offset().top - 300;
    //   const Top4 = $(".chunk5").offset().top - 300;
    //   const scrollTop = $(this).scrollTop();
    //   if (scrollTop > 180) {
    //     $("#navbar").css({
    //       position: "fixed",
    //       top: "0",
    //       background: "#fff",
    //       "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.14)"
    //     });
    //   } else {
    //     $("#navbar").css({
    //       position: "absolute",
    //       top: "4.7rem",
    //       background: "none",
    //       "box-shadow": "0 0px 0px rgba(0, 0, 0, 0.14)"
    //     });
    //   }
    //   if (scrollTop < Top1) {
    //     $("#navbar span.active").removeClass("active");
    //     $("#navbar span")
    //       .eq(0)
    //       .addClass("active");
    //   } else if (scrollTop < Top2) {
    //     $("#navbar span.active").removeClass("active");
    //     $("#navbar span")
    //       .eq(1)
    //       .addClass("active");
    //   } else if (scrollTop < Top3) {
    //     $("#navbar span.active").removeClass("active");
    //     $("#navbar span")
    //       .eq(2)
    //       .addClass("active");
    //   } else if (scrollTop < Top4) {
    //     $("#navbar span.active").removeClass("active");
    //     $("#navbar span")
    //       .eq(3)
    //       .addClass("active");
    //   } else if (scrollTop > Top4) {
    //     $("#navbar span.active").removeClass("active");
    //     $("#navbar span")
    //       .eq(4)
    //       .addClass("active");
    //   }
    // });
    // $("#carousel-example-generic").on("slide.bs.carousel", function(event) {
    //   let $hoder = $("#carousel-example-generic").find(".item"),
    //     $items = $(event.relatedTarget);
    //   let getIndex = $hoder.index($items);
    //   if (getIndex) {
    //     $("#hp-indicators .active").removeClass("active");
    //     $("#hp-indicators li")
    //       .eq(getIndex)
    //       .addClass("active");
    //   } else {
    //     $("#hp-indicators .active").removeClass("active");
    //     $("#hp-indicators li")
    //       .eq(0)
    //       .addClass("active");
    //   }
    // });
    // $("#hp-indicators li").click(function() {
    //   $("#hp-indicators .active").removeClass("active");
    //   if (!$(this).hasClass("active")) {
    //     $(this).addClass("active");
    //   }
    // });
  },
  methods: {
    scrollTo(ele, speed) {
      if (!speed) speed = 300;
      if (!ele) {
        $("html,body").animate({ scrollTop: 0 }, speed);
      } else {
        if (ele.length > 0)
          $("html,body").animate(
            { scrollTop: $(ele).offset().top - 80 },
            speed
          );
      }
      return false;
    },
    JumpLink(){
      window.open('https://beian.miit.gov.cn')
    }
  }
};
</script>

<style>
.beian::hover{
  color: red;
}
html {
  font-size: 13px !important;
}
.chunk1 {
  position: relative;
  /* background-color: #00eaff; */
  /* z-index: -2; */
  background-image: linear-gradient(
      135deg,
      rgba(0, 94, 138, 0.22) 0%,
      rgba(0, 94, 138, 0.25) 23%,
      rgba(10, 147, 194, 0.25) 75%,
      rgba(20, 200, 249, 0.25) 100%
    ),
    linear-gradient(#00eaff, #00eaff);
  background-blend-mode: normal, normal;
}
#navbar {
  color: #7d8189;
  font-weight: bold;
  position: absolute;
  top: 4.7rem;
  left: 0;
  line-height: 6rem;
  width: 100%;
  z-index: 1000;
  /* background: #fff; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.14);  */
}
#navbar span.active {
  color: #43b1f8;
}
#navbar span:hover {
  cursor: pointer;
  color: #43b1f8;
}
.chunk2 {
  position: relative;
  padding: 3rem 0;
  background-color: #4c4c4c;
}
.text1 {
  margin: 1rem 0;
  font-family: PingFang-SC-Bold;
  font-size: 1.6rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3.3rem;
  letter-spacing: 0rem;
  color: #ffffff;
}

.botton {
  margin: 1rem 0;
  min-height: 4.6rem;
  border-radius: 3rem;
  border: solid 0.06rem #ffffff;
}
.num {
  font-family: PingFang-SC-Bold;
  font-size: 2rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 6rem;
  letter-spacing: 0rem;
  color: #ffffff;
}
.chunk3 {
  position: relative;
  padding: 6rem 0;
}
.title {
  font-family: PingFang-SC-Bold;
  font-size: 2.88rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 4rem;
  letter-spacing: 0rem;
  color: #000000;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1.32rem;
}
#xttd {
  margin-left: 3%;
}
.xttdimg {
  text-align: center;
}
.xttdimg img {
  width: 2.8rem;
}
.chunk3 .lable {
  min-height: 2.28rem;
  font-family: PingFang-SC-Bold;
  font-size: 1.8rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 2.28rem;
  letter-spacing: 0rem;
  color: #000000;
}
.chunk3 .synopsis {
  margin-top: 1rem;
  min-height: 9.12rem;
  font-family: PingFang-SC-Regular;
  font-size: 1.2rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 2.28rem;
  letter-spacing: 0rem;
  color: #4d4d4d;
}
.chunk4 {
  position: relative;
  padding: 6rem 0;
  min-height: 51.6rem;
  background-color: #f5f5f5;
}
.mac {
  width: 42rem;
  height: 33.6rem;
  margin: auto;
  background: url("../assets/mac.png") center no-repeat;
  background-size: 100% 100%;
}
.carousel-inner {
  position: relative;
  width: 94% !important;
  margin: 0% 3%;
  overflow: hidden;
}
.carousel-inner > .item > img {
  line-height: 1;
  width: 100%;
  margin-top: 4%;
  /* margin: 4% 3%; */
}

#hp-indicators li {
  padding-left: 4rem;
  /* text-align: center; */
  list-style-type: none;
  width: 21.6rem;
  margin: auto;
  line-height: 4.2rem;
  font-family: PingFang-SC-Regular;
  font-size: 1.8rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #000000;
}
#hp-indicators li.active {
  background: url(../assets/current.png) center no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
}
#hp-indicators li:not(.active):hover {
  background: url(../assets/current.png) center no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  -webkit-filter: opacity(50%);
  filter: opacity(50%);
}

.chunk5 {
  position: relative;
  padding: 6rem 0;
  min-height: 43.2rem;
  font-family: PingFang-SC-Regular;
  font-size: 1.2rem;
}
.line {
  width: 50%;
  border-right: 0.1rem solid #d7d7d7;
  min-height: 15rem;
}
.chunk5 .lable {
  /* width: 42rem; */
  margin-bottom: 1.8rem;
  /* height: 2.52rem; */
  font-size: 1.8rem;
  font-weight: bold;
  color: #000000;
}
.chunk5 .tel {
  height: 4.74rem;
  font-family: Impact;
  font-size: 3.84rem;
  letter-spacing: 0rem;
  color: #1f7dbc;
}
.introduce {
  min-height: 17.64rem;
  /* width: 29.58rem; */
  margin: auto;
  line-height: 2.7rem;
}
.introduce img {
  margin-right: 1rem;
  width: 2.2rem;
}

.chunk6 {
  position: relative;
  padding: 6rem 0;
  line-height: 2;
}
.chunk6 .c-left {
  padding-right: 3rem;
}
.chunk6 .c-right {
  padding-left: 3rem;
}
.chunk6 .subtitle {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
.chunk6 .lable {
  font-size: 1.2rem;
  font-weight: bold;
  padding: 2rem 0 1rem 0;
}
.chunk6 .content {
  font-size: 1.2rem;
}
.chunk6 .lin {
  margin-left: 1rem;
}
.chunk6 .lin:before {
  content: "• ";
  margin-left: -1rem;
}
.footer {
  padding: 2.34rem;
  /* height: 15rem; */
  background-color: #00e2ff;
  font-family: PingFang-SC-Regular;
  font-size: 1.2rem;
  color: #ffffff;
  text-align: center;
  line-height: 2;
}

@media (max-width: 768px) {
  .chunk3 .lable {
    margin-top: 1rem;
    text-align: center;
  }
  .chunk3 .synopsis {
    font-size: 1.4rem;
    text-align: center;
  }
  #xttd {
    margin-left: 0;
  }
  .chunk6 .c-left,
  .chunk6 .c-right {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media (max-width: 500px) {
  .mac {
    width: 29rem;
    height: 23rem;
  }
  html {
    font-size: 12px !important;
  }
}
@media (max-width: 374px) {
  .mac {
    width: 24rem;
    height: 19rem;
  }
  html {
    font-size: 10px !important;
  }
}

.lt-title {
  font-family: PingFang-SC-Medium;
  font-size: 3.38rem;
  /* color: #000000; */
  background: linear-gradient(to right, #b2f7ff 38%, #59eeff 52%, #00e5ff 100%);
  -webkit-background-clip: text;
  color: transparent;
  text-align: center;
}

.mdl-xls {
  height: 12rem;
  line-height: 12rem;
  /* background-color: #d2ffff; */
  transition: 0.8s;
  background-size: 400% auto;
  background-image: linear-gradient(
      90deg,
      #d2ffff 0%,
      #e5ffff 50%,
      #ffffff 100%
    ),
    linear-gradient(#ffffff, #d2ffff);
}
.mdl-xls:hover {
  background-position: right center; /* change the direction of the change here */
  transition: 0.8s;
  background-size: 200% auto;
  background-image: linear-gradient(90deg, #ffffff 0%, #e5ffff 100%),
    linear-gradient(#e5ffff, #e5ffff);
}
.mdl-xls-active {
  height: 12rem;
  line-height: 12rem;
  background-position: right center;
  background-size: 200% auto;
  background-image: linear-gradient(90deg, #ffffff 0%, #e5ffff 100%),
    linear-gradient(#e5ffff, #e5ffff);
  background-blend-mode: normal, normal;
}
.mdl-yx {
  height: 9rem;
  line-height: 9rem;
  /* background-color: #eed4ff; */
  transition: 0.8s;
  background-size: 500% auto;
  background-image: linear-gradient(
      90deg,
      #eed4ff 0%,
      #eed4ff 47%,
      #ffffff 100%
    ),
    linear-gradient(#eed4ff, #ffffff);
}
.mdl-yx:hover {
  background-position: right center; /* change the direction of the change here */
  transition: 0.8s;
  background-size: 500% auto;
  background-image: linear-gradient(
      90deg,
      #eed4ff 0%,
      #eed4ff 47%,
      #ffffff 100%
    ),
    linear-gradient(#ffffff, #eed4ff);
  /* background-blend-mode: normal, normal; */
}
.mdl-yx-active {
  height: 9rem;
  line-height: 9rem;
  background-position: right center;
  background-size: 500% auto;
  background-image: linear-gradient(
      90deg,
      #eed4ff 0%,
      #eed4ff 47%,
      #ffffff 100%
    ),
    linear-gradient(#ffffff, #f9f0ff);
  background-blend-mode: normal, normal;
}
.mdl-sc {
  height: 18rem;
  line-height: 18rem;
  /* background-color: #d3ffd4; */
  transition: 0.8s;
  background-size: 300% auto;
  background-image: linear-gradient(
      90deg,
      #e1ffe2 0%,
      #d3ffd4 50%,
      #ffffff 100%
    ),
    linear-gradient(#ffffff, #d3ffd4);
}
.mdl-sc:hover {
  background-position: right center; /* change the direction of the change here */
  transition: 0.8s;
  background-size: 200% auto;
  background-image: linear-gradient(
      -90deg,
      #e1ffe2 0%,
      #ffffff 50%,
      #d3ffd4 100%
    ),
    linear-gradient(#e1ffe2, #d3ffd4);
}
.mdl-sc-active {
  height: 18rem;
  line-height: 18rem;
  background-image: linear-gradient(
      90deg,
      #ffffff 0%,
      #d3ffd4 50%,
      #d3ffd4 100%
    ),
    linear-gradient(#e1ffe2, #d3ffd4);
  background-blend-mode: normal, normal;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue